import { useNavigate } from "react-router-dom";
import fsnRoutes from "./FsnRoutes";


const AppNavigation = () => {
  const navigate = useNavigate();

  const handleNavigation = (onTap) => {
    const { NavigationType, FSN } = onTap;
console.log("Handling navigation with onTap:", JSON.stringify(onTap));
    switch (NavigationType) {
      case "3":
        if (FSN) {
          const matchedRoute = fsnRoutes.find((item) => item.fsn === FSN)?.route;
          if (matchedRoute) {
            // Save onTap to localStorage
            localStorage.setItem("onTap", JSON.stringify(onTap));

            // Navigate without query parameters
            navigate(matchedRoute, { replace: onTap.FAI.replace });
          } else {
            console.warn("No route matched for FSN:", FSN);
          }
        } else {
          console.warn("Missing FSN for NavigationType 3");
        }
        break;

      default:
        console.warn("Unhandled NavigationType:", NavigationType);
        break;
    }
  };

  return { handleNavigation };
};

export default AppNavigation;